import { W as WuiSkeletonLine$1, d as defineCustomElement$1 } from './p-rSqjxn-v.js';

const WuiSkeletonLine = WuiSkeletonLine$1;
const defineCustomElement = defineCustomElement$1;

export { WuiSkeletonLine, defineCustomElement };
